import { IconButton } from '@mui/material'
import React from 'react'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { Link } from 'react-router-dom';


const EditIcon = ({ to }) => {
    return (
        <Link to={to} >
            <IconButton aria-label="update" >
                <DriveFileRenameOutlineIcon sx={{ color: "#C86337", fontSize: 26 }} />
            </IconButton>
        </Link>
    )
}

export default EditIcon